import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=15d9217c&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=ts"
export * from "./message-bubble.vue?vue&type=script&lang=ts"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=15d9217c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d9217c",
  null
  
)

export default component.exports